import { en, uk } from '../localization';

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { typeLocalization } from '../constants';

// the translations
// (tip move them in a JSON file and import them)
const resources = {
    [typeLocalization.EN]: {
        translation: en,
    },
    [typeLocalization.UK]: {
        translation: uk,
    },
};

i18n.use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: typeLocalization.UK,

        keySeparator: false, // we do not use keys in form messages.welcome

        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    });

export default i18n;
